import axios from '@axios';
import { AxiosPromise } from 'axios';

const API_URL = '/contact-attempts';

/**
 * Creates a new contact attempt.
 *
 * @param {string} email - The email of the contact attempt.
 * @param {string} message - The message of the contact attempt.
 * @returns {Promise<any>} A Promise that resolves to the response from the server.
 *
 * @example
 * createContactAttempt({
 *   email: 'test@example.com',
 *  message: 'Hello, World!',
 *  name: 'John Doe'
 * });
 */
export async function createContactAttempt({ email, message, name }: { email: string; message: string; name: string }): AxiosPromise {
    return axios.post(API_URL, {
        data: { email, message, name },
    });
}


export async function createCVContact({ email, name, phone, message, open_position, file }: { email: string; name: string; phone: string; message: string; open_position?: string; file?: number }): AxiosPromise {
    return axios.post('/contact-cvs', {
        data: { email, name, phone, message, open_position, file },
    });
}
export async function createioAcademyContact({ email, name, course, message, area, file }: { email: string; name: string; course: string; message: string; area?: string; file?: number }): AxiosPromise {
    return axios.post('/contacts-io-academy', {
        data: { email, name, course, message, area, file },
    });
}
